var _ = require("../../../uam/module.js")(module.exports, {
  namespace: "ua.preview.phone",
  title: "Control Preview: Phone",
  description: "Read-only preview renderer for phone values.",
  fields: {
    "value": { title: "Value", type: "*", description: "Phone value to preview." }
  }
});

var helper = require("./helpers/control.preview.js");

exports.render = async function(options) {
  var text = helper.valueToText(options.value).trim();
  if (!text) {
    return helper.renderDoc({
      n: "span",
      c: "ua-control-preview-empty",
      i: "Not provided"
    });
  }

  return helper.renderDoc({
    n: "a",
    c: "ua-control-preview-link",
    href: "tel:" + text.replace(/\s+/g, ""),
    i: helper.normalizePhone(text)
  });
};

/* Plain-text twin of render() for non-DOM surfaces (emails, logs, exports):
 * the same readable value, as a string. "" means nothing to show. */
exports.toText = function(options) {
  var text = helper.valueToText((options || {}).value).trim();
  return text ? helper.normalizePhone(text) : "";
};
